/* TES theme behaviour: tier cards, smooth anchors, tabs, sliders. Vanilla, no libraries. No sticky add to cart bar (Dennis, 15 October 2026).
   Every part checks for its elements first and does nothing when they are missing. */
(function () {
  'use strict';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $all(sel, root) {
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; }
  }
  function scrollToEl(el) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
    catch (e) { el.scrollIntoView(true); }
  }

  /* ---------- Prices ---------- */
  function formatPrice(raw) {
    if (raw == null) return '';
    var s = String(raw).trim();
    if (!s) return '';
    if (/[^0-9.]/.test(s)) return s;                       // already formatted, e.g. "$34.99"
    if (s.indexOf('.') === -1 && s.length >= 3) return '$' + (parseInt(s, 10) / 100).toFixed(2); // cents from Liquid
    var n = parseFloat(s);
    return isNaN(n) ? s : '$' + n.toFixed(2);
  }
  function data(el, names) {
    if (!el) return '';
    for (var i = 0; i < names.length; i++) {
      var v = el.getAttribute(names[i]);
      if (v != null && v !== '') return v;
    }
    return '';
  }
  function setText(sel, value, root) {
    if (!value) return;
    $all(sel, root).forEach(function (t) { t.textContent = value; });
  }

  /* ---------- Tier cards ---------- */
  var TIER_SEL = '[data-tes-tier], .tes-tier input[type="radio"], input[type="radio"][data-price], input[type="radio"][data-tes-price]';

  function tierCard(opt) {
    if (opt.tagName !== 'INPUT') return opt;
    var wrap = opt.parentElement ? opt.parentElement.closest('[data-tes-tier]') : null;
    return opt.closest('label') || wrap || opt.parentElement || opt;
  }
  function tierInput(opt) {
    if (opt.tagName === 'INPUT') return opt;
    return opt.querySelector('input[type="radio"]');
  }
  function tierGroup(opt) {
    return opt.closest('[data-tes-tiers]') || opt.closest('[role="radiogroup"]') || opt.closest('form') || opt.closest('.shopify-section') || document;
  }
  function tierValues(opt) {
    var input = tierInput(opt);
    var srcs = [opt, input, tierCard(opt)];
    function pick(names) {
      for (var i = 0; i < srcs.length; i++) { var v = data(srcs[i], names); if (v) return v; }
      return '';
    }
    return {
      price: pick(['data-price-formatted', 'data-tes-price-label', 'data-tes-price', 'data-price']),
      compare: pick(['data-compare-formatted', 'data-tes-compare-label', 'data-tes-compare', 'data-compare-at', 'data-compare']),
      per: pick(['data-tes-per', 'data-per-bottle', 'data-per']),
      label: pick(['data-tes-label', 'data-label', 'data-title']),
      variant: pick(['data-tes-variant', 'data-variant-id', 'data-variant']) || (input && input.name === 'id' && /^\d+$/.test(input.value) ? input.value : '')
    };
  }

  function selectTier(opt, silent) {
    var group = tierGroup(opt);
    var options = $all(TIER_SEL, group === document ? document : group);
    var chosenCard = tierCard(opt);
    options.forEach(function (o) {
      var card = tierCard(o);
      var on = card === chosenCard;
      var input = tierInput(o);
      if (input && on && !input.checked) input.checked = true;
      card.classList.toggle('is-selected', on);
      if (card.getAttribute('role') === 'radio' || card.hasAttribute('aria-checked')) {
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        if (card.tagName !== 'INPUT' && card.getAttribute('role') === 'radio') card.setAttribute('tabindex', on ? '0' : '-1');
      }
    });

    var v = tierValues(opt);
    var price = formatPrice(v.price);
    var compare = formatPrice(v.compare);
    var scope = group === document ? document : (group.closest('.shopify-section') || group);
    setText('[data-tes-cta-price], [data-tes-selected-price], [data-tes-price-target]', price, scope);
    setText('[data-tes-cta-compare], [data-tes-selected-compare], [data-tes-compare-target]', compare, scope);
    setText('[data-tes-selected-per]', v.per, scope);
    setText('[data-tes-selected-label]', v.label, scope);
    if (v.variant) {
      var form = opt.closest('form');
      var idInputs = form ? $all('input[name="id"]:not([type="radio"])', form) : [];
      idInputs.forEach(function (i) { i.value = v.variant; });
      $all('[data-tes-variant-target]').forEach(function (i) { if ('value' in i) i.value = v.variant; });
    }
    if (!silent) {
      try { document.dispatchEvent(new CustomEvent('tes:tier', { detail: v })); } catch (e) {}
    }
  }

  function initTiers() {
    var options = $all(TIER_SEL);
    if (!options.length) return;
    var seen = [];
    options.forEach(function (opt) {
      var card = tierCard(opt);
      if (seen.indexOf(card) !== -1 || card.dataset.tesReady) return;
      seen.push(card);
      card.dataset.tesReady = '1';
      var input = tierInput(opt);
      if (input) {
        input.addEventListener('change', function () { if (input.checked) selectTier(opt); });
      } else {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a[href]')) return;
          selectTier(opt);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectTier(opt); return; }
          var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
          if (!keys[e.key]) return;
          e.preventDefault();
          var list = $all(TIER_SEL, tierGroup(opt)).map(tierCard).filter(function (c, i, a) { return a.indexOf(c) === i; });
          var i = list.indexOf(card);
          var next = list[(i + keys[e.key] + list.length) % list.length];
          if (next) { selectTier(next); next.focus(); }
        });
      }
    });
    // Start from the preselected tier in each group (checked input, aria-checked, or data-selected)
    var groups = [];
    options.forEach(function (o) { var g = tierGroup(o); if (groups.indexOf(g) === -1) groups.push(g); });
    groups.forEach(function (g) {
      var list = $all(TIER_SEL, g === document ? document : g);
      var start = null;
      list.forEach(function (o) {
        if (start) return;
        var input = tierInput(o), card = tierCard(o);
        if ((input && input.checked) || card.getAttribute('aria-checked') === 'true' || card.hasAttribute('data-selected') || card.classList.contains('is-selected')) start = o;
      });
      if (start) selectTier(start, true);
    });
  }

  /* ---------- Smooth scroll for #anchors ---------- */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a) return;
      if (a.host && a.host !== window.location.host) return;
      var hash = a.hash;
      if (!hash || hash.length < 2) return;
      var id;
      try { id = decodeURIComponent(hash.slice(1)); } catch (err) { id = hash.slice(1); }
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var drawer = document.getElementById('MenuDrawer');
      var closer = drawer && drawer.classList.contains('is-open') ? drawer.querySelector('.js-drawer-close') : null;
      if (closer) closer.click();
      setTimeout(function () {
        scrollToEl(target);
        if (window.history && history.replaceState) { try { history.replaceState(null, '', hash); } catch (err) {} }
      }, closer ? 30 : 0);
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    $all('[data-tes-tabs]').forEach(function (box) {
      if (box.dataset.tesReady) return;
      box.dataset.tesReady = '1';
      var tabs = $all('[role="tab"]', box).filter(function (t) { return t.closest('[data-tes-tabs]') === box; });
      var panels = $all('[role="tabpanel"]', box).filter(function (p) { return p.closest('[data-tes-tabs]') === box; });
      if (!tabs.length) return;
      function panelFor(tab, i) {
        var id = tab.getAttribute('aria-controls');
        var p = id ? document.getElementById(id) : null;
        return p || panels[i] || null;
      }
      function activate(index, focus) {
        tabs.forEach(function (t, i) {
          var on = i === index;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          t.classList.toggle('is-active', on);
          var p = panelFor(t, i);
          if (p) { p.hidden = !on; p.classList.toggle('is-active', on); }
        });
        if (focus && tabs[index]) tabs[index].focus();
      }
      tabs.forEach(function (t, i) {
        if (t.tagName === 'BUTTON' && !t.getAttribute('type')) t.setAttribute('type', 'button');
        t.addEventListener('click', function (e) { e.preventDefault(); activate(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = n - 1;
          if (next === null) return;
          e.preventDefault();
          activate(next, true);
        });
      });
      var start = 0;
      tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') start = i; });
      activate(start);
    });
  }

  /* ---------- Sliders: a scroll snap row with prev and next arrows ([data-tes-slider], e.g. tes-results) ---------- */
  function initSliders() {
    $all('[data-tes-slider]').forEach(function (box) {
      if (box.dataset.tesReady) return;
      var track = box.querySelector('[data-tes-slider-track]');
      if (!track) return;
      box.dataset.tesReady = '1';
      var prev = box.querySelector('[data-tes-slider-prev]');
      var next = box.querySelector('[data-tes-slider-next]');
      function step() {
        var first = track.children[0], second = track.children[1];
        if (first && second) return second.offsetLeft - first.offsetLeft;
        return track.clientWidth;
      }
      function paint() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function go(dir) {
        try { track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); }
        catch (e) { track.scrollLeft += dir * step(); }
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(paint, 60); }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
    });
  }

  function init() {
    [initTiers, initTabs, initSliders].forEach(function (fn) { try { fn(); } catch (e) {} });
  }
  try { initAnchors(); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
